module.exports = __webpack_public_path__ + "img/673-6d1d4b.png";